import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
	{
		path: '',
		children: [
			{
				path: '',
				redirectTo: 'view',
				pathMatch: 'full',
			},
			{
				path: 'Account',
				loadChildren: () =>
					import('./dashboard/account/account.module').then(
						(m) => m.AccountModule,
					),
			},
			{
				path: 'view',
				loadChildren: () =>
					import('./views/views.module').then((m) => m.ViewsModule),
				canActivate: [MsalGuard],
			},
			{
				path: 'auth',
				loadChildren: () =>
					import('./auth.routes').then((m) => m.AuthRoutingModule),
			},
			{
				path: '**',
				redirectTo: 'view',
			},
		],
	},
];
